import { api } from "@/services/api";
import { AddAdvertViewModel, AdvertModel } from "../types";

const merchantApi = api.injectEndpoints({
  endpoints: (build) => ({
    addAdvertView: build.query<AddAdvertViewModel, void>({
      query: (payload) => {
        return {
          url: "api/Merchant/AddAdvertView",
          method: "get",
          data: payload,
        };
      },
    }),
    addEditAdvert: build.mutation<AdvertModel[], any>({
      query: (payload) => {
        return {
          url: "api/Merchant/AddUpdateAdvert",
          method: "post",
          data: payload,
        };
      },
    }),
    getAdverts: build.mutation<AdvertModel[], void>({
      query: (payload) => {
        return {
          url: "api/Merchant/GetAdverts",
          method: "post",
          data: payload,
        };
      },
    }),
    updateAdvertStatus: build.mutation<AdvertModel[], any>({
      query: (payload) => {
        return {
          url: "api/Post/UpdatePostStatus",
          method: "post",
          data: payload,
        };
      },
    }),
    deleteAdvert: build.mutation<number, any>({
      query: (payload) => {
        return {
          url: "api/Post/DeletePost",
          method: "post",
          data: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddAdvertViewQuery,
  useAddEditAdvertMutation,
  useGetAdvertsMutation,
  useUpdateAdvertStatusMutation,
  useDeleteAdvertMutation,
} = merchantApi;

export default merchantApi;
